import Emoji_0 from './Emoji_0'
import Emoji_A from './Emoji_A'
import Emoji_B from './Emoji_B'
import Emoji_C from './Emoji_C'
import Emoji_D from './Emoji_D'
import Emoji_E from './Emoji_E'
import Emoji_F from './Emoji_F'
import Emoji_G from './Emoji_G'
import Emoji_H from './Emoji_H'
import Emoji_IJK from './Emoji_IJK'
import Emoji_L from './Emoji_L'
import Emoji_M from './Emoji_M'
import Emoji_N from './Emoji_N'
import Emoji_OP from './Emoji_OP'
import Emoji_QR from './Emoji_QR'
import Emoji_S from './Emoji_S'
import Emoji_TUV from './Emoji_TUV'
import Emoji_W from './Emoji_W'
import Emoji_XYZ from './Emoji_XYZ'

export interface IEmoji {
    id: number
    width: number
    height: number
    /** comma separated (optional) */
    tags?: string
}

const Emoji: Record<string, IEmoji> = {
    ...Emoji_0,
    ...Emoji_A,
    ...Emoji_B,
    ...Emoji_C,
    ...Emoji_D,
    ...Emoji_E,
    ...Emoji_F,
    ...Emoji_G,
    ...Emoji_H,
    ...Emoji_IJK,
    ...Emoji_L,
    ...Emoji_M,
    ...Emoji_N,
    ...Emoji_OP,
    ...Emoji_QR,
    ...Emoji_S,
    ...Emoji_TUV,
    ...Emoji_W,
    ...Emoji_XYZ,
}

export default Emoji
